// Chakra imports
import { Text, useColorModeValue, Grid } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card.js';
import React from 'react';
import EditableInformation from './EditableInformation';

export default function AddressInfo(props) {
  const { studentData, isEditing = false, onFieldChange } = props;

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'gray.400';
  const cardShadow = useColorModeValue(
    '0px 18px 40px rgba(112, 144, 176, 0.12)',
    'unset',
  );
  return (
    <Card mb={{ base: '0px', '2xl': '20px' }}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Dirección
      </Text>
      <Grid
        templateColumns={{
          base: "1fr",
          lg: "1fr 1fr",
        }}
        templateRows={{
          base: "repeat(3, 1fr)",
          lg: "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}
        mt={{ base: "20px", lg: "20px" }}>
        <EditableInformation
          mb={2}
          boxShadow={cardShadow}
          title="Calle"
          value={studentData?.address?.street}
          isEditing={isEditing}
          field="street"
          onFieldChange={(field, value) => {
            onFieldChange('address', {
              ...studentData?.address,
              [field]: value
            });
          }}
        />
        <EditableInformation
          mb={2}
          boxShadow={cardShadow}
          title="Número"
          value={studentData?.address?.number}
          isEditing={isEditing}
          field="number"
          onFieldChange={(field, value) => {
            onFieldChange('address', {
              ...studentData?.address,
              [field]: value
            });
          }}
        />
        <EditableInformation
          mb={2}
          boxShadow={cardShadow}
          title="Apartamento"
          value={studentData?.address?.apartment}
          isEditing={isEditing}
          field="apartment"
          onFieldChange={(field, value) => {
            onFieldChange('address', {
              ...studentData?.address,
              [field]: value
            });
          }}
        />
        <EditableInformation
          mb={2}
          boxShadow={cardShadow}
          title="Ciudad"
          value={studentData?.address?.city}
          isEditing={isEditing}
          field="city"
          onFieldChange={(field, value) => {
            onFieldChange('address', {
              ...studentData?.address,
              [field]: value
            });
          }}
        />
        <EditableInformation
          mb={2}
          boxShadow={cardShadow}
          title="Localidad"
          value={studentData?.address?.locality}
          isEditing={isEditing}
          field="locality"
          onFieldChange={(field, value) => {
            onFieldChange('address', {
              ...studentData?.address,
              [field]: value
            });
          }}
        />
      </Grid>
    </Card>
  );
}
